export default class RoomOccupancy {
  static fromJSON(json) {
    return new RoomOccupancy({
      adults: json.maxAdults,
      children: json.maxChildren
    })
  }

  constructor({ adults, children }) {
    this.adults = adults
    this.children = children
  }
}
